export const c = Object.freeze({
  IDLE: 'idle',
  CREATING_SESSION: 'creating-session',
  SYNCING_PATIENTS: 'syncing-patients',
  READY: 'ready',
  ERROR: 'error',
});

export const LOCAL_STORAGE_KEY = 'auto-join';
